const Wrapper = () => import('@/components/Wrapper');
const Users = () => import('@/views/ShoppingMall/Users');

const Classify = () => import('@/views/ShoppingMall/Classify');
const ShoppingCar = () => import('@/views/ShoppingMall/ShoppingCar');
const GoodsDetail = () => import('@/views/ShoppingMall/goodsDetail');
const Paying = () => import('@/views/ShoppingMall/SubmitOrder/paying');
const Invoice = () => import('@/views/ShoppingMall/SubmitOrder/invoice');
const Address = () => import('@/views/ShoppingMall/AddressPart/address');
const AddNewSite = () => import('@/views/ShoppingMall/AddressPart/addNewSite');
const PaySuccess = () => import('@/views/ShoppingMall/SubmitOrder/paySuccess');
const adLink = () => import('@/views/ShoppingMall/adLink/ccfx');
// const discountCard = () => import('@/views/ShoppingMall/discountCard/discountList')
const Unclaimed = () => import('@/views/ShoppingMall/discountCard/unclaimed');
// 订单
const MyOrder = () => import('@/views/ShoppingMall/MyOrderPart/myOrder');
const OrderDetail = () => import('@/views/ShoppingMall/MyOrderPart/orderDetail');
const trackLogistics = () => import('@/views/ShoppingMall/MyOrderPart/trackLogistics');
const OrderInvoice = () => import('@/views/ShoppingMall/MyOrderPart/OrderInvoice');
const InvoiceEmail = () => import('@/views/ShoppingMall/MyOrderPart/InvoiceEmail');
// 售后 After sales
const AfterSalesList = () => import('@/views/ShoppingMall/aftersales/List');
const ChoiceType = () => import('@/views/ShoppingMall/aftersales/ChoiceType');
const BackOrder = () => import('@/views/ShoppingMall/aftersales/backOrder');
const BackHistory = () => import('@/views/ShoppingMall/aftersales/History');
const BackOrderDetail = () => import('@/views/ShoppingMall/aftersales/backOrderDetail');
// 优惠券列表
const CouponList = () => import('@/views/coupon/coupon');

const AccountSelection = () => import('@/views/ShoppingMall/MemberCard/accountSelection.vue');
const vipBuyTips = () => import('@/views/ShoppingMall/MemberCard/vip-buy-tips.vue');
const MemberActivation = () => import('@/views/ShoppingMall/MemberCard/activation');
const MemberActivationSuccess = () => import('@/views/ShoppingMall/MemberCard/activationSuccess');
const MemberList = () => import('@/views/ShoppingMall/MemberCard/list');
const MemberCode = () => import('@/views/ShoppingMall/MemberCard/memberCode');

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: 'store-home'
  },
  {
    path: '/store-home',
    name: 'store-home',
    component: () => import('@/views/ShoppingMall/StoreHome'),
    meta: {
      title: '酷开商城',
      openTagList: ['wx-open-launch-weapp'],
      jsApiList: ['wx-open-launch-weapp', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
      showFooter: true
    }
  },
  // {
  //   path: '/collageDetail',
  //   name: 'collageDetail',
  //   component: collageDetail,
  //   meta: {
  //     title: '酷开商城',
  //     openTagList: ['wx-open-launch-weapp'],
  //     jsApiList: ['wx-open-launch-weapp', 'onMenuShareTimeline', 'onMenuShareAppMessage']
  //   }
  // },
  {
    path: '/await-coupon',
    name: 'await-coupon',
    component: () => import('@/views/coupon/await-coupon')
  },
  {
    path: '/order/preOrder',
    name: 'preOrder',
    component: () => import('@/views/order/pre-order.vue'),
    meta: {
      title: '预订单处理'
    }
  },
  {
    path: '/order/tv/kdInfo',
    name: 'kdInfo',
    component: () => import('@/views/order/tv/kdInfo.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/order/tv/electronicInv',
    name: 'electronicInv',
    component: () => import('@/views/order/tv/electronicInv.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/order',
    name: 'order',
    component: Wrapper,
    children: [
      {
        path: 'list',
        name: 'my-order',
        component: MyOrder,
        meta: {
          title: '我的订单'
        }
      },
      {
        path: 'detail',
        name: 'order-detail',
        component: OrderDetail,
        meta: {
          title: '订单详情'
        }
      },
      {
        path: 'trackLogistics',
        name: 'track-logistics',
        component: trackLogistics,
        meta: {
          title: '物流追踪'
        }
      }
      // {
      //   path: 'invoice',
      //   name: 'order-invoice',
      //   component: OrderInvoice,
      //   meta: {
      //     title: '发票'
      //   }
      // },
      // {
      //   path: 'Invoice-email',
      //   name: 'Invoice-email',
      //   component: InvoiceEmail,
      //   meta: {
      //     title: '发送电子发票'
      //   }
      // }
    ]
  },
  {
    path: '/aftersales',
    name: 'aftersales',
    component: Wrapper,
    children: [
      {
        name: 'aftersales-list',
        path: 'list',
        component: AfterSalesList,
        meta: {
          title: '售后记录'
        }
      },
      {
        name: 'choice-type',
        path: 'choice-type',
        component: ChoiceType,
        meta: {
          title: '选择服务类型'
        }
      },
      {
        path: 'back-order',
        name: 'back-order',
        component: BackOrder,
        meta: {
          title: '售后申请'
        }
      },
      {
        path: 'history',
        name: 'back-history',
        component: BackHistory,
        meta: {
          title: '协商历史'
        }
      },
      {
        path: 'back-order-detail',
        name: 'back-order-detail',
        component: BackOrderDetail,
        meta: {
          title: '售后详情'
        }
      }
    ]
  },
  //
  {
    path: '/store-classify',
    name: 'store-classify',
    component: Classify,
    meta: {
      title: '商品分类',
      showFooter: true,
      openTagList: ['wx-open-launch-weapp'],
      jsApiList: ['wx-open-launch-weapp']
    }
  },
  {
    path: '/store-shopping-car',
    name: 'store-shopping-car',
    component: ShoppingCar,
    meta: {
      title: '购物车',
      showFooter: true,
      openTagList: ['wx-open-launch-weapp'],
      jsApiList: ['wx-open-launch-weapp']
    }
  },
  {
    path: '/store-users',
    name: 'store-users',
    component: Users,
    meta: {
      title: '我的',
      showFooter: true,
      openTagList: ['wx-open-launch-weapp'],
      jsApiList: ['wx-open-launch-weapp']
    }
  },
  {
    path: '/goodsDetail',
    name: 'goods-detail',
    component: GoodsDetail,
    meta: {
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
      title: '商品详情'
    }
  },
  // AccountSelection
  {
    path: '/account-selection',
    name: 'account-selection',
    component: AccountSelection,
    meta: {
      title: '确认帐号'
    }
  },
  {
    path: '/vip-buy-tips',
    name: 'vip-buy-tips',
    component: vipBuyTips,
    meta: {
      title: '确认影视源'
    }
  },
  {
    path: '/member-activation',
    name: 'member-activation',
    component: MemberActivation,
    meta: {
      title: '权益激活'
    }
  },
  {
    path: '/member-activation-success',
    name: 'member-activation-success',
    component: MemberActivationSuccess,
    meta: {
      title: '权益激活'
    }
  },
  {
    path: '/member-code',
    name: 'member-code',
    component: MemberCode,
    meta: {
      title: '会员卡'
    }
  },
  {
    path: '/member-list',
    name: 'member-list',
    component: MemberList,
    meta: {
      title: '权益激活'
      // isLogin: true
    }
  },
  {
    path: '/paying',
    name: 'paying',
    component: Paying,
    meta: {
      title: '确认订单'
    }
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: Invoice
  },
  {
    path: '/address',
    name: 'address',
    component: Address,
    meta: {
      title: '我的地址'
    }
  },
  {
    path: '/add-new-site',
    name: 'add-new-site',
    component: AddNewSite,
    meta: {
      title: '新增/修改地址'
    }
  },
  {
    path: '/pay-success',
    name: 'pay-success',
    component: PaySuccess,
    meta: {
      openTagList: ['wx-open-launch-weapp'],
      jsApiList: ['wx-open-launch-weapp', 'chooseImage', 'previewImage'],
      title: '支付成功'
    }
  },
  {
    path: '/ad-link/ccfx',
    name: 'ad-link',
    component: adLink,
    meta: {
      title: '酷开商城'
    }
  },
  {
    path: '/discount-card',
    name: 'discount-card',
    component: () => import('@/views/ShoppingMall/discountCard/discountList'),
    meta: {
      title: '我的优惠券'
    }
  },
  {
    path: '/unclaimed',
    name: 'unclaimed',
    component: Unclaimed,
    meta: {
      title: '待领取优惠券'
    }
  },
  // {
  //   path: '/change-mobile',
  //   name: 'change-mobile',
  //   component: changePartnerMobile,
  //   meta: {
  //     title: '更换手机号'
  //   }
  // },
  // {
  //   path: '/new-mobile',
  //   name: 'new-mobile',
  //   component: newMobile,
  //   meta: {
  //     title: '更换手机号'
  //   }
  // },
  {
    path: '/coupon',
    name: 'coupon',
    component: CouponList,
    meta: {
      title: '优惠券列表'
    }
  },
  {
    path: '/',
    component: Wrapper,
    children: [
      {
        path: 'special',
        name: 'special',
        component: () => import('@/views/Special/index'),
        meta: {
          // title: '专题页',
          title: ''
        }
      }
    ]
  }
];
export default routes;
